import { Context, Getters } from 'vuex-smart-module';
import { Store } from 'vuex';

import { IUser } from '@/types';
import { IModuleSettings } from '../types';

import AppStore from '@/store/appstore';
import AuthState from './state';

export default class AuthGetters extends Getters<AuthState> {
  app!: Context<typeof AppStore>;

  $init(store: Store<typeof AppStore>): void {
    this.app = AppStore.context(store);
  }

  get user(): IUser | undefined {
    return this.app.state.appData.user;
  }

  get isAuthorized() {
    return !!this.getters.user?.idUser;
  }

  get settings(): IModuleSettings {
    const settings =
      this.app.state.appData.settings?.modules?.auth || ({} as IModuleSettings);

    settings.birthdayReminderProfileEdit = settings.birthdayReminderProfileEdit ?? true;

    return settings;
  }
}
